import { useEffect } from 'react';
import { listenMap } from '../../channels/mapChannel';
import { useMapStore } from '../../stores/map/useMapStore';

export function useMapChannel() {

    useEffect(() => {

        const unsubscribe = listenMap(({ tipo, payload }) => {

            const {
                setOpenMap,
                setCloseMap,
                setLoadingMap,
                setRoute,
                setTrajeto,
                setSelectedPoint,
                setPositionsRange,
                clearPositionsRange,
                setLastPosition,
                clearLastPosition,
                appendPositionRange,
                receiveMapFocus
            } = useMapStore.getState();

            
            if (tipo === 'map-open') {

                setOpenMap(payload, false);

            }

            if (tipo === 'map-close') {

                setCloseMap(false);

            }

            if (tipo === 'map-loading') {

                setLoadingMap(payload, false);

            }

            if (tipo === 'map-route') {

                setRoute(payload, false);

            }
            
            if (tipo === 'map-trajeto') {

                setTrajeto(payload, false);

            }
            
            if(tipo === 'map-point') {
                setSelectedPoint(payload, false);
            }

            if(tipo === 'map-focus') {
                receiveMapFocus(payload);
            }
            
            if(tipo === 'map-positions-range') {
                setPositionsRange(payload, false);
            } 

            if(tipo === 'map-clear-positions-range') {
                clearPositionsRange(false);
            }

            if(tipo === 'map-last-position') {
                setLastPosition(payload, false);
            }

            if(tipo === 'map-clear-last-position') {
                clearLastPosition(false);
            }

            if(tipo === 'map-append-positions-range') {
                appendPositionRange(payload, false);
            }

        });

        return unsubscribe;

    }, []);

}